import React, { Component } from "react"
import { Table, Icon, message, Row } from "antd"
import "./Index.scss"
import { observer, inject } from "mobx-react"
import recoveryIcon from "app/styles/images/sp/recovery.svg"
import WarningTip from "app/components/normal/WarningTip/WarningTip"
import FlexableFileName from "app/components/normal/FlexableFileName"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import Highlighter from "app/components/normal/HighLighter"
import highlightable from "app/utils/highlightable"
import { PREPARE_RUN, RUNNING } from 'app/utils/const'

@inject("entrance", "auth", "pgsReport") @observer
export default class ReportCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      downLoadModal: false,
      showEditModal: false,
      dataIndex: 0,
      options: [],
      editGroupName: "",
      groupNameHistory: [],
    }
  }

  showEditModal = () => {
    const { data, pgsReport: { getGroupListById } } = this.props

    this.setState({
      showEditModal: true,
      editGroupName: data.groupName
    })
    getGroupListById(data.groupId, "deleted")
  }

  closeModal = (modal, cb = () => { }) => {
    this.setState({
      [modal]: false
    }, cb)
  }

  recoveryGroup = (id) => {
    const { store: { recoveryGroup, tableData }, groupIndex } = this.props
    recoveryGroup(id)
      .then(
        res => {
          tableData.splice(groupIndex, 1)
          message.success("家系恢复成功")
        },
        err => {
          message.error(err.message)
        }
      )
  }

  renderGroupButtons = () => {
    let { data = {} } = this.props

    return (
      <Row
        type="flex"
        align="middle"
        justify="center"
        className="info-buttons"
      >
        <Row
          type="flex"
          align="middle"
          className="recovery-family"
          onClick={() => this.recoveryGroup(data.groupId)}
        >
          <img src={recoveryIcon} alt="" /> 恢复家系报告
        </Row>
      </Row>
    )
  }

  toggleGroupNameHistory = (visible) => {
    if (visible) {
      //调接口
      const { store: { getReportHistory }, data: { groupId } } = this.props
      getReportHistory(groupId)
        .then(
          res => {
            this.setState({
              groupNameHistory: res
            })
          },
          err => {
            message.error("历史记录获取失败")
          }
        )
    } else {
      this.setState({
        groupNameHistory: []
      })
    }
  }

  renderGroupName = () => {
    const { data = {} } = this.props
    const { groupNameHistory } = this.state
    const { queryMap: { keywords } } = this.props.store
    const groupName = (
      <MaterialTip
        title={data.groupName}
      >
        <div className="cursor-p ellipsis">
          <Highlighter
            highlightStyle={{ fontWeight: "normal" }}
            searchWords={highlightable(data.groupName, keywords) ? [data.groupName] : []}
            textToHighlight={data.groupName}
          />
        </div>
      </MaterialTip>
    )

    if (data.hasHistory) {
      return (
        <WarningTip
          type="warningTip"
          text={groupName}
          justify="start"
          overlayClassName="ta-c"
          historyData={groupNameHistory}
          onVisibleChange={this.toggleGroupNameHistory}
        />
      )
    } else {
      return (
        <div>{groupName}</div>
      )
    }
  }

  checkOperatable = (record) => {
    return record.state !== RUNNING && record.state !== PREPARE_RUN
  }

  render() {
    const { data = {} } = this.props
    const renderContent = (text, record, index) => {
      const obj = {
        children: text,
        props: {},
      }
      if (record.state === PREPARE_RUN || record.state === RUNNING) {
        obj.props.colSpan = 0
      }
      return obj
    }

    const columns = [
      {
        title: "文件名称",
        dataIndex: "filename",
        width: "24.1%",
        sorter: (a, b) => a.filename.localeCompare(b.filename),
        render: (filename, record, index) => {
          const { queryMap: { keywords } } = this.props.store

          return (
            <FlexableFileName filename={filename} keywords={keywords} isEqual={true} />
          )
        }
      }, {
        width: "12.71%",
        title: "样本名称",
        dataIndex: "sampleName",
        sorter: (a, b) => a.sampleName.localeCompare(b.sampleName),
        render: (text) => {
          const { queryMap: { keywords } } = this.props.store

          return (
            <MaterialTip title={text}>
              <div className="sample-name ellipsis">
                <Highlighter
                  highlightStyle={{ fontWeight: "normal" }}
                  searchWords={highlightable(text, keywords) ? [text] : []}
                  textToHighlight={text || ""}
                />
              </div>
            </MaterialTip>
          )
        }
      }
    ]

    if (data.reportList) {  // 新建组传文件且文件正在运行会没有reportList字段从而报错
      const statistical = [
        {
          title: "Total_Reads/Pairs",
          className: "ta-r",
          dataIndex: "totalReads",
          render: (text, record, index) => {
            const stateData = [
              {
                text: "数据准备运行",
                className: "pre-run pgs-state-element"
              },
              {
                text: "数据正在运行",
                className: "running pgs-state-element"
              },
            ]
            switch (record.state) {
              case 0:
                return {
                  children: (
                    <Row type="flex" justify="center" align="middle">
                      <div className={stateData[0].className}>
                        <Icon type="hourglass" />
                        {stateData[0].text}
                      </div>
                    </Row>
                  ),
                  props: {
                    colSpan: 6
                  }
                }
              case 1:
                return {
                  children: (
                    <Row type="flex" justify="center" align="middle">
                      <div className={stateData[1].className}>
                        <Icon type="clock-circle-o" />
                        {stateData[1].text}
                      </div>
                    </Row>
                  ),
                  props: {
                    colSpan: 6
                  }
                }
              default:
                return (<div>{text}</div>)
            }
          }
        }, {
          title: "MT_ratio(%)",
          className: "ta-r",
          dataIndex: "mtRatio",
          render: renderContent
        }, {
          title: "Map_Ratio(%)",
          className: "ta-r",
          dataIndex: "mapRatio",
          render: renderContent
        }, {
          title: "Duplicate(%)",
          className: "ta-r",
          dataIndex: "duplicate",
          render: renderContent
        }, {
          title: "GC_Count(%)",
          className: "ta-r",
          dataIndex: "gcCount",
          render: renderContent
        }, {
          title: "*SD",
          className: "ta-r",
          dataIndex: "sd",
          render: renderContent
        }
      ]
      columns.push(...statistical)
    }

    return (
      <Row type="flex" className="recycle-card">
        <div className="card-left">
          <div className="content">
            <div className="info">
              <Row type="flex" justify="start" align="middle" className="info-group">
                <label>数据类型：</label><div className="text-content">{data.appName}</div>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>所在家系：</label>
                <div className="text-content">
                  {this.renderGroupName()}
                </div>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>报告数量：</label><div className="text-content">{data.totalDataCount}</div>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>创建时间：</label><div className="text-content">{data.createTime}</div>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>删除时间：</label><div className="text-content">{data.deleteTime}</div>
              </Row>
            </div>
            {
              this.renderGroupButtons()
            }
          </div>
        </div>
        <Table
          columns={columns}
          className="recycle-card-content"
          rowKey={record => record.reportId}
          dataSource={data.reportList.slice()} pagination={false} />
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/pgs/RecycleCard/index.js